import { RESOURCE_CONCEPT_FAIL, RESOURCE_CONCEPT_FETCH, RESOURCE_CONCEPT_REQUEST } from "../store/config";

const resourceConceptInit = {
	isFetching: false,
	list: [],
	pages: {
		current: 0,
		per_page: 0,
		total: 0
	},
	edit: {},
	error: null,
	timestamp: null
}

const resource_concepts = (state = resourceConceptInit, action) => {
	switch (action.type) {
		case RESOURCE_CONCEPT_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				timestamp: action.timestamp
			}
		case RESOURCE_CONCEPT_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case RESOURCE_CONCEPT_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default resource_concepts;


// WEBPACK FOOTER //
// ./src/reducers/resource_concept.js